<template>
    <vue-modal :open="open">
        <div class="bax-modal-content bax-modal-icon-content text-center">
            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                <i class="icon-delete"></i>
            </div>
            <h2>Change bag volume</h2>
            <p>Are you sure?<br>This will delete any nutrients you have added to the bag contents.</p>
            <div class="bax-modal-action-items">
                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="closeModal">Cancel</button>
                <button type="button" class="bax-btn bax-btn-blue-brand" @click.prevent="onChange()">Continue</button>
            </div>
        </div>
    </vue-modal>
</template>
<script>

export default {
    name: 'ChangeBagModal',
    props: {
        open: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        closeModal() {
            this.$emit('modal_change_bag_close', false);
        },
        onChange() {
            this.$emit('modal_change_bag_close', true);
            // if (!this.submitting) {
            //     this.submitting = true;
            //     this.error = false;
            //     PatientRegistationService.deletePatientRegistation(this.deleteRequestItem.id)
            //     .then((res) => {
            //         this.submitting = false;
            //         if (!res.data.deleted) {
            //             this.error = 'Sorry, something went wrong';
            //         } else {
            //             this.$emit('modal_delete_close', this.deleteRequestItem.id);
            //         }
            //     });
            // }
        },
    },
};
</script>
